import { Component, OnInit, Input, Output, EventEmitter, Self, Optional, AfterViewInit, OnChanges, SimpleChanges } from '@angular/core';
import { FormControl, Validators, ControlValueAccessor, NgControl } from '@angular/forms';
import { copyObj } from '@angular/animations/browser/src/util';

@Component({
  selector: 'app-dao-dropdown',
  templateUrl: './dao-dropdown.component.html',
  styleUrls: ['./dao-dropdown.component.css']
})
export class DaoDropdownComponent implements ControlValueAccessor, OnChanges {
  @Input('label') label: string;
  @Input('options') options: any[];
  @Input('value') value: string;
  @Input('Mandatory') Mandatory: boolean;
  @Input('disabled') disabled: boolean;
  @Input('required') required: boolean;
  @Input('showAdd') showAdd: boolean = false;
  @Input('showDelete') showDelete: boolean = false;
  @Input('searchable') searchable:boolean = false;

  @Output() onAdd: EventEmitter<any> = new EventEmitter<any>();
  @Output() onDelete: EventEmitter<any> = new EventEmitter<any>();

  @Output() valueChange: EventEmitter<string> = new EventEmitter<string>();

  private errorMessages = new Map<string, () => string>();
  public filteredOptionsList;

  constructor(@Self() @Optional() public control: NgControl) {
    this.control && (this.control.valueAccessor = this);
    this.errorMessages.set('required', () => `${this.label} is required.`);
  }
  ngOnChanges(changes: SimpleChanges): void {
    if(changes.options){
      if(changes.options.currentValue){
        this.filteredOptionsList = changes.options.currentValue.map(x => Object.assign({}, x));
      }
    }
  }


  public get invalid(): boolean {
    return this.control ? this.control.invalid : false;
  }

  public get showError(): boolean {
    if (!this.control) {
      return false;
    }

    const { dirty, touched } = this.control;

    return this.invalid ? (dirty || touched) : false;
  }

  public get errors(): Array<string> {
    if (!this.control) {
      return [];
    }

    const { errors } = this.control;
    return Object.keys(errors).map(key => this.errorMessages.has(key) ? this.errorMessages.get(key)() : <string>errors[key] || key);
  }

  public onChangeFn = (_: any) => { };

  public onTouchedFn = () => { };

  public registerOnChange(fn: any): void {
    this.onChangeFn = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouchedFn = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  public writeValue(obj: any): void {
    this.value = obj;
  }

  onChange() {
    this.onChangeFn(this.value);
    this.valueChange.emit(this.value);
  }

  clearSelection(event: Event) {
    event.stopPropagation();
    this.value = null;
    this.onChange();
  }
  compareObjects(obj1: any, obj2: any) {
    return obj1 == obj2;
  }
  public addClick(event: Event) {
    event.stopPropagation();
    this.onAdd.emit(event);
  }

  public deleteClick(event: Event) {
    event.stopPropagation();
    this.value = null;
    this.onDelete.emit(event);
  }
  public filterMyOptions(event: string) {
    if (!event || event.trim() == "") {
      this.filteredOptionsList = this.options.map(x => Object.assign({}, x));
      return;
    }
    let filtered = this.options.filter(function (option) {
      if (!option.VisibleValue) {
        return false;
      }
      return option.VisibleValue.toLowerCase().includes(event.toLowerCase());
    })
    this.filteredOptionsList = filtered;
  }
}
